import React from 'react';
import { Link } from 'react-router-dom';

const blogPosts = [
  {
    id: 1,
    title: 'Best Picnic Spot Near Nagpur',
    date: '25',
    month: 'June',
    author: 'Admin',
    comments: 2,
    image: '/images/keyword/51.jpg',
    link: '/Best‑Picnic‑Spot‑Near‑Nagpur'
  },
  {
    id: 2,
    title: 'Family Picnic Spot Near Nagpur',
    date: '25',
    month: 'June',
    author: 'Admin',
    comments: 2,
    image: '/images/keyword/50.jpg',
    link: '/Family-Picnic-Spot-Near-Nagpur'
  },
  {
    id: 3,
    title: 'One Day Adventure Resorts Near Nagpur',
    date: '25',
    month: 'June',
    author: 'Admin',
    comments: 2,
    image: '/images/keyword/7.jpg',
    link: '/One-Day-Adventure-Resorts-Near-Nagpur'
  }
];

const NewsSection = () => {
  return (
    <section className="news-section pt-0 light-bg mx-60 border-shape-bottom">
      <div className="auto-container">
        {/* Title */}
        <div className="title-box text-center">
          <div className="sub-title">Nature & Relaxation</div>
          <h2 className="sec-title">Woodland Escape Highlights</h2>
        </div>

        {/* Blog Posts */}
        <div className="row">
          {blogPosts.map((post) => (
            <div className="col-lg-4 news-block" key={post.id}>
              <div className="inner-box">
                <div className="image">
                  <Link to={post.link}>
                    <img src={post.image} alt={post.title} />
                  </Link>
                </div>
                <div className="lower-content">
                  
                  <h3>
                    <Link to={post.link}>{post.title}</Link>
                  </h3>
                  <div className="link-btn">
                    <Link to={post.link} className="theme-btn btn-style-three">
                      <span>Read More</span>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default NewsSection;
